import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { ICTask, ICUserDealspace } from './Interfaces';
import moment from 'moment';

export const getTimeAmPm = (time: string) => {
  return new Date(time).toLocaleTimeString('en-US', {
    hour: 'numeric',
    hour12: true,
    minute: 'numeric',
  });
};

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const getDealTasksByTaskID = (
  taskId?: string,
  dealTaskList: ICTask[] = []
): ICTask[] => {
  if (!taskId) {
    return [];
  }

  return dealTaskList.filter(
    ({ type, isCompleted, parentId }) =>
      parentId === taskId &&
      isCompleted !== true &&
      (type === 'risk' || type === 'issue')
  );
};

export const getTaskColor = (task: ICTask, dealTaskList: ICTask[]) => {
  const yellow = '#FFAB00';
  const red = '#FF5630';
  const green = '#36B37E';
  if (!task.dueDate) {
    return yellow;
  }

  if (moment(new Date()).isAfter(task.dueDate, 'day') && !task.isCompleted) {
    return red;
  }

  console.log('getDealTasksByTaskID', getDealTasksByTaskID(task.id));

  if (getDealTasksByTaskID(task.id, dealTaskList).length > 0) {
    return yellow;
  }

  return green;
};

export function useDebounce(value: string, delay: number): string {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      // Set debouncedValue to value (passed in) after the specified delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      // Return a cleanup function that will be called every time ...
      // ... useEffect is re-called. useEffect will only be re-called ...
      // ... if value changes (see the inputs array below).
      // This is how we prevent debouncedValue from changing if value is ...
      // ... changed within the delay period. Timeout gets cleared and restarted.
      // To put it in context, if the user is typing within our app's ...
      // ... search box, we don't want the debouncedValue to update until ...
      // ... they've stopped typing for more than 500ms.
      return () => {
        clearTimeout(handler);
      };
    },
    // Only re-call effect if value changes
    // You could also add the "delay" var to inputs array if you ...
    // ... need to be able to change that dynamically.
    [value, delay]
  );

  return debouncedValue;
}

export const reorderList = (
  list: any[],
  startIndex: number,
  endIndex: number
) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export default function useOnScreen<Element extends HTMLElement>(): [
  boolean,
  React.RefCallback<Element>
] {
  const [intersecting, setIntersecting] = useState(false);
  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) =>
        setIntersecting(entry.isIntersecting)
      ),
    [setIntersecting]
  );

  const currentElement = useCallback(
    (ele: Element | null) => {
      if (ele) {
        observer.observe(ele);
      } else {
        observer.disconnect();
        setIntersecting(false);
      }
    },
    [observer, setIntersecting]
  );

  return [intersecting, currentElement];
}

export const dealspaceUserIsOwner = (
  dealspaceList: ICUserDealspace[],
  id: string
) => {
  const dealspace = dealspaceList?.find(item => item.id === id);
  console.log('aaa', dealspace, localStorage.getItem('useremail'));

  if (
    dealspace &&
    dealspace.dealspaceOwner === localStorage.getItem('useremail')
  ) {
    return false;
  } else {
    return true;
  }
};

export function groupByName(list: any, keyGetter: any) {
  const map = new Map();
  list?.forEach((item: any) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  const keys = Array.from(map.keys());
  return keys;
}

export function groupByList(list: any, keyGetter: any) {
  const map = new Map();
  list?.forEach((item: any) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

export const unsecuredCopyToClipboard = (text: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  } else {
    console.log('insecure connection');
  }
};

export const getListStyle = (isDraggingOver: boolean) => ({
  background: isDraggingOver ? '#eee' : 'transparent',
});

export const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  marginBottom: 10,
  // change background colour if dragging
  background: isDragging ? 'transparent' : 'transparent',

  // styles we need to apply on draggables
  ...draggableStyle,
});

export const highlight = (value: any, args: any): any => {
  if (!args || args === '') {
    return value;
  }
  var re = new RegExp(args, 'gi');
  return value.replace(re, '<mark>$&</mark>');
};
